module.exports = __webpack_public_path__ + "static/media/ios.2928664f.svg";